import * as types from "../types";

const INITIAL_STATE = {
  email: "",
  username: "",
  password: "",
  confirmPassword: "",
  showPassword: false,
  token: "",
  firstName: "",
  lastName: "",
  birthdate: "2019-01-01",
  gender: "0",
  mobile: "",
  maritalStatus: "1",
  numOfChildren: "0",
  address: "",
  city: "AMMAN",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.REGISTER_SECOND_UPDATE_STATE:
      return { ...state, ...action.payload };
    case types.REGISTER_SECOND_RESET_STATE:
      return INITIAL_STATE;
    case types.REGISTER_SECOND_SETUP_USER:
      const user = action.payload;
      const {
        EMAIL,
        USERNAME,
        PASSWORD,
        FIRSTNAME,
        LASTNAME,
        BIRTHDATE,
        GENDER,
        MOBILE,
        ADDRESS,
        CITY,
      } = user;
      return {
        ...state,
        email: EMAIL,
        username: USERNAME,
        password: PASSWORD,
        firstName: FIRSTNAME,
        lastName: LASTNAME,
        birthdate: BIRTHDATE,
        gender: GENDER,
        mobile: MOBILE,
        address: ADDRESS,
        CITY: CITY,
      };
    default:
      return state;
  }
};
